const state = {
  isMasterFetched: false,
  showLoginModal: false,
  showPrintModal: false,
  showKssPrintModal: false,
  showInternetPrintModal: false
}
const getters = {
  IsMasterFetched (state: any): boolean {
    return state.isMasterFetched
  },
  showLoginModal (state: any) {
    return state.showLoginModal
  },
  showPrintModal (state: any) {
    return state.showPrintModal
  },
  showKssPrintModal (state: any) {
    return state.showKssPrintModal
  },
  showInternetPrintModal (state: any) {
    return state.showInternetPrintModal
  }
}
const mutations = {
  COMPLETE_FETCH_MASTER (state: any): void {
    state.isMasterFetched = true
  },
  SET_SHOW_LOGIN_MODAL (state: any, showLoginModal: boolean) {
    state.showLoginModal = showLoginModal
  },
  SET_SHOW_PRINT_MODAL (state: any, showPrintModal: boolean) {
    state.showPrintModal = showPrintModal
  },
  SET_SHOW_KSS_PRINT_MODAL (state: any, showKssPrintModal: boolean) {
    state.showKssPrintModal = showKssPrintModal
  },
  SET_SHOW_INTERNET_PRINT_MODAL (state: any, showInternetPrintModal: boolean) {
    state.showInternetPrintModal = showInternetPrintModal
  }
}
const actions = {}
export default {
  state,
  getters,
  mutations,
  actions
}
